import { render, staticRenderFns } from "./TheHomeButton.vue?vue&type=template&id=293c5a37&scoped=true&"
import script from "./TheHomeButton.vue?vue&type=script&lang=js&"
export * from "./TheHomeButton.vue?vue&type=script&lang=js&"
import style0 from "./TheHomeButton.vue?vue&type=style&index=0&id=293c5a37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293c5a37",
  null
  
)

export default component.exports